// extracted by css-extract-rspack-plugin
export default {"labelWrapper":"SaveQuestionForm-module__labelWrapper___JrGC5","label":"SaveQuestionForm-module__label___CIiEZ","labelActive":"SaveQuestionForm-module__labelActive___BhEli"};